import React from 'react';
import * as ReactDOM from "react-dom";
import Game from "../Game";
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {format} from "react-string-format";
import {Col, Container, Row} from "react-bootstrap";
import Subscriptions from "../Subscribe/Subscriptions";
import GameChats from "../Chat/GameChats";

class AdminHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isLoadedData: false,
            error: null,
            settings: [],
            userId: null,
            loginError: null,
        };
    }

    componentDidMount(){
        if(this.props.adminId) {
            fetch(process.env.REACT_APP_API_URL + "/admin/" + this.props.adminId.toString() + "/settings", {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoadedData: true,
                            settings: result.settings
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoadedData: true,
                            error
                        });
                    }
                )
        }
    }

    saveSettings(e){
        e.preventDefault();

        const body = {
            'settings': {
                'is_paid_company_allowed': e.target.is_paid_company_allowed.checked,
                'is_paid_apps_allowed': e.target.is_paid_apps_allowed.checked
            }
        };
        console.log(body);

        fetch(format(process.env.REACT_APP_API_URL + '/admin/{0}/settings', this.props.adminId.toString()), {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedData: true,
                        settings: result.settings
                    });
                },

                (error) => {
                    this.setState({
                        isLoadedData: true,
                        error
                    });
                }
            )
    }

    render() {
        const { isLoaded, isLoadedData, settings, loginError} = this.state;

        const { navigate } = this.props;

        if (loginError) {
            navigate('/account');
        }

        let content = null;

        if (isLoadedData) {
            content = <div>
                <section style={{backgroundColor: "#eee"}}>
                    <div className="container py-5">
                        <div className="row">
                            <div className="col">
                                <nav aria-label="breadcrumb" className="bg-light rounded-3 p-3 mb-4">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <a href="/admin">
                                                <button type="button" className="btn btn-primary">Admin panel</button>
                                            </a>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-4">
                                <div className="card mb-4">
                                    <div className="card-body text-center">

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="card mb-4 mb-lg-0">
                                        <div className="card-body p-0">
                                            <ul className="list-group list-group-flush rounded-3">
                                    <h4>Settings</h4>
                                    <form onSubmit={this.saveSettings.bind(this)} class="alert alert-danger">
                                        <input className="form-check-input" type="checkbox" defaultChecked={settings && settings.hasOwnProperty("is_paid_company_allowed") ? settings.is_paid_company_allowed : false}
                                               name="is_paid_company_allowed" />
                                        <label className="form-check-label" htmlFor="create_new">Paid company allowed</label>
                                        <br/>

                                        <input className="form-check-input" type="checkbox" defaultChecked={settings && settings.hasOwnProperty("is_paid_apps_allowed") ? settings.is_paid_apps_allowed : false}
                                               name="is_paid_apps_allowed" />
                                        <label className="form-check-label" htmlFor="create_new">Paid apps allowed</label>
                                        <br/><br/>
                                        <input class="btn btn-outline-danger ms-1" type="submit" value="Save"/>
                                    </form>
                                                <br/>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>;
        } else {
            content = <h1>Loading...</h1>
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>

    }
}

export default withRouter(AdminHome);
